
import React, { Component, PropTypes } from 'react';

import DatePicker from 'react-datepicker';
import Client from './Client';
var moment = require('moment');
import Translate from '../layout/Translate';

export default class Clients extends Component {



    componentDidUpdate () {
        let actions = this.props.actions;


        if (this.props.order.client.promise) {

           //console.log(this.props.order.client.promise);
           //console.log(this.props.order.client.promise);

            this.props.order.client.promise.json().then(function (result) {
                actions.setClient(result);
            });
        }
    }


    saveClients() {
        this.props.actions.saveClients();
    }

    render () {
        const { departure } = this.props.order;
        const order = this.props.order;
        const tour = this.props.tour;
        const user = this.props.user;

        return (
        <div className="order__form form">

            <div className="form__row">
                <table className="table order__table services">
                    {order.clients.map((client, i)=>
                        
                            <Client key={i} client={client} i={i} order={order} actions={this.props.actions} />

                    )}

                </table>
            </div>



            <div className="form__buttons">
                <button className={"form__button form__button_success" + ((order.isFetching)?'form__button_fetching':'')} onClick={this.saveClients.bind(this)}>
                    <Translate slug="order__next-step-2" />
                </button>
            </div>
        </div>
                
        );
    }
}














// WEBPACK FOOTER //
// ./src/common/components/order/Clients.js